export default {
  comparison: {
    aiCommand: {
      eyebrow: 'Geofleet AI Command Centre',
      title: 'Agentic automation from one command centre',
      intro:
        'While others stop at maps or basic dispatch rules, Geofleet’s AI Command Centre orchestrates auto carrier allocation, auto driver allocation, agentic route planning, and intelligent alerts & notifications—with AI Agents acting on your behalf from one control tower.',
      ctaFeatures: 'Explore AI Agents & automation',
      capabilities: {
        agents: {
          title: 'AI Agents',
          body: 'Agentic workflows in the command centre resolve exceptions, reassign work, and coordinate multi-step logistics without waiting on a human dispatcher.',
        },
        carrier: {
          title: 'Auto carrier allocation',
          body: 'AI matches every shipment to the right carrier using capacity, cost, SLA, lane history, and live conditions—continuously, not batch overnight.',
        },
        driver: {
          title: 'Auto driver allocation',
          body: 'Drivers are assigned and rebalanced automatically from the same control tower as carriers, with proximity, skills, shift rules, and load in one model.',
        },
        routes: {
          title: 'Agentic route planning',
          body: 'Routes are planned and replanned by ML that reacts to traffic, new orders, failed attempts, and hub constraints—far beyond static route files.',
        },
        alerts: {
          title: 'Alerts & AI notifications',
          body: 'Proactive alerts for SLA risk, delays, capacity crunches, and exceptions—prioritized by AI so teams fix what matters first.',
        },
        tower: {
          title: 'One command centre',
          body: 'Everything runs from a single Geofleet command centre: no patchwork of siloed tools for routing, dispatch, partners, and comms.',
        },
      },
    },
  },
};
